import * as Sentry from "@sentry/react";

import { LISBlock, LISCaseList } from "pwapi";

export const labelForBlock = (block?: LISBlock, blockCase?: LISCaseList) => {
  const specimen = blockCase?.specimens.find(
    (s) => s.id === block?.specimen_id
  );
  if (!specimen) {
    Sentry.captureException(
      new Error(
        `Could not find Specimen #${block?.specimen_id} for Block #${block?.id}`
      )
    );
  }
  return `${specimen?.name || ""}${block?.name || ""}`;
};
